export const _CSR_SHOP_CHEKCOUT_ID = "CSR_CHECKOUTID"; // checkoutID
export const _CSR_ACCESS_TOKEN = "CSR_ACCESSTOKEN"; // accessToken
export const _CSR_SHOP_CART_ID = "CSR_SHOPCARTID"; // 购物车ID
export const _CSR_COMPANY_LOCATION = "company_location"; // 公司位置，用于b2b
export const _CSR_LOGIN_EMAIL = "CSR_LOGIN_EMAIL"; // 用户登录邮箱
export const _CSR_USER_NAME = "CSR_USER_NAME"; // 用户名
export const _CSR_IS_B2b = "isB2b"; // 是否b2b
export const _CSR_TOKEN_REFRESHTOKEN = "refresh_token"; // 是否b2b

export const _CSR_ID_TOKEN = "id_token"; // id_token，用于b2b
export const _CSP_STORENFONT_TOKEN = "storefront_token"; // 记录b2b的storefront_token
export const _CSP_ACCOUNT_HASH = "account_hash"; // 记录account的hash，用来回退页面
export const _CSP_HEADER_CLASS = "tsws-header-v1"; // 记录account的hash，用来回退页面
export const _CSR_B2B_TOKEN_CALLBACK_URL = "b2b_token_callback_url"; // 记录b2b的token_callback_url
export const _CSR_LATEST_SHOP_CART_PRODUCT_ID =
  "CSR_LATEST_SHOP_CART_PRODUCT_ID"; // 记录最新添加到购物车的商品ID
// 用于判断订单状态的
export const _CSP_ORDER_STATUS_MAP = {
  delivered: {
    className: "csr-account__delivered-status",
    statusTxt: "Delivered",
  },
  fulfilled: { className: "csr-account__shipped-status", statusTxt: "Shipped" },
  cancelled: {
    className: "csr-account__cancelled-status",
    statusTxt: "Cancel",
  },
  authorized: {
    className: "csr-account__authorized-status",
    statusTxt: "Authorized",
  },
  progress: {
    className: "csr-account__progress-status",
    statusTxt: "In Progress",
  },
  partial: {
    className: "csr-account__progress-status",
    statusTxt: "partial",
  },
};
export const _CSP_ORDER_STATUS = {
  _DELIVERED: "delivered",
  _FULFILLED: "fulfilled",
  _CANCELLED: "cancelled",
  _AUTHORIZED: "authorized",
  _PROGRESS: "progress",
};
